<script lang="ts" context="module">
  import type { GenericSpace } from "models/spaces";
  export type InlineMention = Pick<
    GenericSpace,
    "title" | "uuid" | "spaceType" | "color" | "icon" | "iconDark"
  >;
  export type MentionType = "members" | "spaces" | "docs";
</script>

<script lang="ts">
  import cx from "classnames";
  import ColoredOpacityBackground from "$components/+blocks/ColoredOpacityBackground/ColoredOpacityBackground.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { docURL, spaceURL } from "app/utils/urls";
  import { slugify } from "$utils/strings";
  import { Squircle, File } from "$components/+blocks/OVIcon";
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";

  export let mentionType: MentionType;
  export let item: InlineMention;
  export let communitySlug: string = "";
  export let editable: boolean;
  export let selected: boolean;
  export let icon: string | undefined = undefined;

  let opacity = 10;
</script>

{#if mentionType === "members"}
  <button
    class="relative inline-flex overflow-hidden rounded"
    on:click
    on:mouseenter={() => (opacity = 20)}
    on:mouseleave={() => (opacity = 10)}
    data-drag-handle
  >
    <span
      class={cx("relative inline px-1 text-editor-mention-blue", {
        "rounded-md bg-gray-200 dark:bg-gray-600": editable && selected,
        "cursor-grab": editable,
      })}
    >
      <ColoredOpacityBackground backgroundClass="bg-editor-mention-blue" {opacity} />
      @{item.title}
    </span>
  </button>
{:else}
  <a
    class="relative inline-flex overflow-hidden no-underline hover:cursor-pointer"
    href={mentionType === "spaces"
      ? spaceURL({
          communitySlug,
          spaceUuid: item.uuid,
          spaceSlug: slugify(item.title ?? ""),
          spaceType: item.spaceType,
        })
      : docURL({
          communitySlug,
          docUuid: item.uuid,
          docSlug: slugify(item.title ?? ""),
        })}
    data-drag-handle
    on:mouseenter={() => (opacity = 20)}
    on:mouseleave={() => (opacity = 10)}
  >
    <span
      class={cx(
        "relative inline-flex gap-1 rounded px-1 leading-[23px] text-gray-500 hover:bg-black/10 dark:text-gray-300 dark:hover:bg-white/10 dark:hover:text-gray-100",
        editable ? "cursor-grab" : "cursor-pointer",
        {
          "rounded-md bg-gray-200 dark:bg-gray-600": editable && selected,
          "bg-black/5 dark:bg-white/5": mentionType === "docs",
        }
      )}
    >
      {#if icon}
        <span class="inline-flex">
          <Avatar
            mainImage={icon}
            radius="rounded-[3px]"
            wrapperClasses="mt-auto mb-auto not-prose"
          />
        </span>
      {:else}
        <span style:color={item.color} class="inline-flex items-center">
          <OVIcon icon={mentionType === "spaces" ? Squircle : File} class="inline-block" />
        </span>
      {/if}

      {item.title}
    </span>
  </a>
{/if}
